import React from 'react';
import type { WhatsAppStatsPeriod, WhatsAppStatsQuery } from './whatsappStatsPeriod';
import { statsPeriodLabel } from './whatsappStatsPeriod';

type Props = {
  value: WhatsAppStatsQuery;
  onChange: (next: WhatsAppStatsQuery) => void;
  compact?: boolean;
};

const PERIODS: WhatsAppStatsPeriod[] = ['daily', 'weekly', 'monthly', 'yearly', 'custom'];

export default function WhatsAppStatsPeriodSelector({ value, onChange, compact = false }: Props) {
  const period = value.period || 'monthly';

  const setPeriod = (next: WhatsAppStatsPeriod) => {
    onChange({
      ...value,
      period: next,
      days: undefined,
    });
  };

  const btnClass = (active: boolean) =>
    `rounded-md px-2.5 py-1.5 text-xs font-medium transition ${
      active
        ? 'bg-gray-900 text-white dark:bg-gray-100 dark:text-gray-900'
        : 'text-gray-600 hover:bg-gray-100 dark:text-gray-300 dark:hover:bg-gray-800'
    }`;

  return (
    <div className={`flex flex-wrap items-center gap-2 ${compact ? '' : 'justify-end'}`}>
      <div className="inline-flex rounded-lg border border-gray-200 bg-white p-0.5 dark:border-gray-600 dark:bg-gray-800">
        {PERIODS.map((p) => (
          <button
            key={p}
            type="button"
            onClick={() => setPeriod(p)}
            className={btnClass(period === p)}
          >
            {statsPeriodLabel(p)}
          </button>
        ))}
      </div>
      {period === 'custom' && (
        <div className="flex flex-wrap items-center gap-2">
          <input
            type="date"
            value={value.startDate || ''}
            onChange={(e) => onChange({ ...value, startDate: e.target.value })}
            className="rounded-lg border border-gray-200 px-2 py-1.5 text-xs dark:border-gray-600 dark:bg-gray-800"
          />
          <span className="text-xs text-gray-400">to</span>
          <input
            type="date"
            value={value.endDate || ''}
            onChange={(e) => onChange({ ...value, endDate: e.target.value })}
            className="rounded-lg border border-gray-200 px-2 py-1.5 text-xs dark:border-gray-600 dark:bg-gray-800"
          />
        </div>
      )}
    </div>
  );
}
